import CustomCard from "../../Component/BasicComponents/Card/CustomCard";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useLeaveViewData,
  useUpdateStatus,
} from "./hooks/useLeave";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { useEffect, useState } from "react";
import { showToast } from "../../utils/toastUtils";
import { Btn } from "../../AbstractElements";
import Loader from "../../assets/loader/loader.gif";
import { sendMediaIds } from "../Onboarding/hooks/OnBoardingRepo";
import pdf from "../../assets/images/pdf_image.png";

const LeaveView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { leaveReqId, rowData } = location.state || {};

  const [isModal, setIsModal] = useState(false);
  const [leaveStatusRemark, setLeaveStatusRemark] = useState("");
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState("");

  const [buttonDisable, setButtonDisable] = useState(false);
  const [buttonStatus, setButtonStatus] = useState("");

  const [attachmentData, setAttachmentData] = useState([]);

  const { data: leaveViewData, isLoading: isLeaveViewLoading } =
    useLeaveViewData({
      id: leaveReqId,
      enable: true,
    });

  useEffect(() => {
    const fetchMediaAttachmentData = async () => {
      const attachment = leaveViewData?.data?.leaveReqId?.Attachment;

      if (attachment) {
        try {
          const mediaId = attachment.split(",").filter(Boolean); // remove empty values
          if (mediaId.length > 0) {
            const response = await sendMediaIds(mediaId);
            const attachmentMediaIdsData = response?.data || [];
            setAttachmentData(attachmentMediaIdsData);
          }
        } catch (error) {
          console.error("Error fetching media attachment data:", error);
        }
      }
    };

    fetchMediaAttachmentData();
  }, [leaveViewData]);

  const currentStatus = leaveViewData?.data?.currentLeaveStatus?.statusName;

  const { mutate } = useUpdateStatus();

  const toggle = () => {
    setIsModal(!isModal);
    setButtonDisable(false);
    setLeaveStatusRemark("");
  };

  const LeaveReqData = leaveViewData?.data?.leaveReqId;
  const LeaveReqLogs = leaveViewData?.data?.logs;
  const LeaveReqStatus = leaveViewData?.data?.currentLeaveStatus;

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const handleImageClick = (imageUrl: string) => {
    setModalImageUrl(imageUrl);
    setIsImageModalOpen(true);
  };

  const handleApproveButtonClick = () => {
    setIsModal(!isModal);
    setButtonStatus("Approve");
  };

  const handleRejectButtonClick = () => {
    setIsModal(!isModal);
    setButtonStatus("Reject");
  };

  const handleApproveSubmit = () => {
    const emojiRegex =
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g;

    const trimmedRemark = leaveStatusRemark.trim();

    if (buttonStatus === "Approve") {
      if (!leaveReqId) {
        showToast.warning("Please Fill the Required Field");
        return;
      }
      // Optional: Check if remark is required for approval
      if (!trimmedRemark || emojiRegex.test(leaveStatusRemark)) {
        showToast.warning("Remark cannot be empty or contain emojis");
        return;
      }

      const body = {
        leaveId: leaveReqId,
        leaveStatus: 2,
        note: leaveStatusRemark,
      };

      setButtonDisable(true);
      mutate(body, {
        onSuccess: () => {
          setIsModal(!isModal);
          navigate("/leave/leaverequest");
          setLeaveStatusRemark("");
          setButtonDisable(false);
          setButtonStatus("");
        },
        onSettled: () => {
          setIsModal(!isModal);
          setLeaveStatusRemark("");
          setButtonDisable(false);
        },
      });
    } else if (buttonStatus === "Reject") {
      if (!leaveReqId) {
        showToast.warning("Please Fill the Required Field");
        return;
      }

      if (!trimmedRemark || emojiRegex.test(leaveStatusRemark)) {
        showToast.warning("Remark cannot be empty or contain emojis");
        return;
      }

      const body = {
        leaveId: leaveReqId,
        leaveStatus: 3,
        note: leaveStatusRemark,
      };

      setButtonDisable(true);
      mutate(body, {
        onSuccess: () => {
          setIsModal(!isModal);
          navigate("/leave/leaverequest");
          setLeaveStatusRemark("");
          setButtonDisable(false);
          setButtonStatus("");
        },
        onSettled: () => {
          setIsModal(!isModal);
          setLeaveStatusRemark("");
          setButtonDisable(false);
          setButtonStatus("");
        },
      });
    }
  };

  const status =
    leaveViewData?.data?.currentLeaveStatus?.statusName?.toLowerCase();

  const getTextColor = (status: string | undefined) => {
    switch (status) {
      case "approved":
        return "green";
      case "rejected":
        return "red";
      case "raised":
        return "orange";
      default:
        return "black";
    }
  };

  return (
    <>
      {!rowData && !leaveReqId ? (
        <div className="text-center py-2">
          <div
            className="spinner-border spinner-border-sm text-primary"
            role="status"
          />
        </div>
      ) : (
        <div>
          <PageHeader title="Leave View" />

          {/* First Two Cards Side by Side */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <div
              style={{
                width: "70%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {/* First Card (Column 7) */}

              <CustomCard
                colSize="lg-7"
                title="Leave Detail"
                content={
                  <>
                    {isLeaveViewLoading ? (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <img
                          src={Loader}
                          alt="Loading..."
                          style={{ height: 40 }}
                        />
                      </div>
                    ) : (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <CustomInput
                            label="From Date"
                            type="date"
                            value={LeaveReqData?.LeaveFrom || ""}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqData?.LeaveFrom
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                          <CustomInput
                            label="To Date"
                            type="date"
                            value={LeaveReqData?.LeaveTo || ""}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqData?.LeaveTo
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <CustomInput
                            label="Leave Requested Date"
                            type="date"
                            value={LeaveReqData?.CreatedAt?.split(" ")[0] || ""}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqData?.CreatedAt
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                          <CustomInput
                            label="Leave Type"
                            type="text"
                            value={LeaveReqData?.LeaveType || ""}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqData?.LeaveType
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <CustomInput
                            label="Leave Duration"
                            type="text"
                            value={LeaveReqData?.leaveDifference}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqData?.leaveDifference
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                          <CustomInput
                            label="Leave Status"
                            type="text"
                            value={LeaveReqStatus?.statusName || ""}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqStatus?.statusName
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <CustomInput
                            label="Leave Reason"
                            type="textarea"
                            value={LeaveReqData?.LeaveReason || ""}
                            style={{
                              flex: 1,
                              border: "0.2px solid #d4d4d4",
                              cursor: "not-allowed",
                              backgroundColor: LeaveReqData?.LeaveReason
                                ? "#F4F5F8"
                                : "transparent",
                            }}
                            disabled={true}
                          />
                        </div>
                        {attachmentData && attachmentData.length > 0 && (
                          <div className="row mb-3">
                            <div className="col-md-12">
                              <label
                                style={{ fontWeight: "500", display: "block" }}
                              >
                                Leave Attachment
                              </label>

                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  flexWrap: "wrap",
                                }}
                              >
                                {attachmentData.map((file: any) => {
                                  const fileUrl = `${BASE_URL}${file.MediaId}`; // ✅ fixed

                                  const isImage =
                                    file.MediaMime?.startsWith("image/");

                                  return (
                                    <div
                                      key={file.MediaId}
                                      style={{ textAlign: "center" }}
                                    >
                                      {isImage ? (
                                        <img
                                          src={fileUrl}
                                          alt={file.MediaName}
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleImageClick(fileUrl)
                                          }
                                        />
                                      ) : (
                                        <>
                                          <img
                                            src={pdf}
                                            alt={file.MediaName}
                                            style={{
                                              width: "auto",
                                              height: "auto",
                                              maxHeight: "100px",
                                              objectFit: "contain",
                                              borderRadius: "8px",
                                              boxShadow:
                                                "0 4px 15px rgba(0, 0, 0, 0.2)",
                                              display: "flex",
                                              cursor: "pointer",
                                              justifyContent: "start",
                                            }}
                                            onClick={() =>
                                              window.open(fileUrl, "_blank")
                                            }
                                          />

                                          <p
                                            style={{
                                              marginTop: "10px",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {file.MediaName}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}

                        {leaveViewData?.data?.leaveReqId?.LeaveRemark && (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <strong>{`Remark : `}</strong>
                            <strong style={{ color: getTextColor(status) }}>
                              {leaveViewData?.data?.leaveReqId?.LeaveRemark ||
                                "Remark Not Available"}
                            </strong>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                }
              />

              {/* Third Card (Column 7) Below First Card */}

              {currentStatus === "Rejected" ? (
                <></>
              ) : (
                <CustomCard
                  title="Take Action"
                  content={
                    <>
                      {!currentStatus ? (
                        <div
                          style={{
                            padding: "20px",
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          <img
                            src={Loader}
                            alt="Loading..."
                            style={{ height: 40 }}
                          />
                        </div>
                      ) : (
                        <div>
                          {currentStatus === "Approved" ? (
                            <></>
                          ) : (
                            <button
                              // onClick={() => setIsModal(!isModal)}
                              onClick={handleApproveButtonClick}
                              className="btn btn-primary"
                            >
                              Approve Leave
                            </button>
                          )}
                          <button
                            onClick={handleRejectButtonClick}
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#c23616",
                              border: "none",
                              marginLeft: "10px",
                            }}
                          >
                            Reject Leave
                          </button>
                        </div>
                      )}
                    </>
                  }
                />
              )}
            </div>
            {/* Second Card (Column 5) */}
            <div style={{ width: "30%" }}>
              <CustomCard
                colSize="xl-5"
                title="Status Logs"
                content={
                  // !LeaveReqLogs ? (
                  //   <div
                  //     style={{
                  //       padding: "20px",
                  //       textAlign: "center",
                  //       width: "100%",
                  //     }}
                  //   >
                  //     <img
                  //       src={Loader}
                  //       alt="Loading..."
                  //       style={{ height: 40 }}
                  //     />
                  //   </div>
                  // ) : (
                  <>
                    {LeaveReqLogs?.map((item: any, index: number) => (
                      <div
                        key={index}
                        style={{
                          border: "1px solid #d4d4d4",
                          padding: "10px",
                          borderRadius: "5px",
                          marginBottom: "10px",
                        }}
                      >
                        <h5>{item?.logTitle}</h5>
                        <p>
                          {item?.loggedBy?.firstName} {item?.loggedBy?.lastName}{" "}
                          | {item?.loggedBy?.employeeCode}
                        </p>
                        <p>{item?.logCreatedAt}</p>
                        <h5>{item?.logNote}</h5>
                      </div>
                    ))}
                  </>
                  // )
                }
              />
            </div>
          </div>

          <RouteModal
            isOpen={isImageModalOpen}
            toggle={() => setIsImageModalOpen(false)}
            title="Attachment Preview"
            size="lg"
            content={
              <div style={{ textAlign: "center" }}>
                <img
                  src={modalImageUrl}
                  alt="Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    borderRadius: "8px",
                  }}
                />
              </div>
            }
          />

          {/* Modal */}
          <RouteModal
            size="md"
            toggle={toggle}
            isOpen={isModal}
            title={
              buttonStatus === "Approve" ? "Approve Leave" : "Reject Leave"
            }
            content={
              <>
                <CustomInput
                  label="Remark"
                  type="textarea"
                  value={
                    /* LeaveReqData?.LeaveReason != ""
                      ? LeaveReqData?.LeaveReason
                      : */ leaveStatusRemark
                  }
                  style={{
                    backgroundColor: "transparent",
                    border: "0.2px solid #d4d4d4",
                    flex: 1,
                  }}
                  asterisk={true}
                  onChange={(e) => setLeaveStatusRemark(e.target.value)}
                />
                <div>
                  {buttonStatus === "Approve" && (
                    <Btn
                      onClick={handleApproveSubmit}
                      disabled={buttonDisable}
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#43B9B2",
                        color: "white",
                        marginRight: "10px",
                      }}
                    >
                      Approve Leave
                    </Btn>
                  )}

                  {buttonStatus === "Reject" && (
                    <button
                      onClick={handleApproveSubmit}
                      disabled={buttonDisable}
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#c23616",
                        border: "none",
                        marginLeft: "10px",
                      }}
                    >
                      Reject Leave
                    </button>
                  )}
                  <button
                    onClick={() => setIsModal(!isModal)}
                    className="btn btn-light"
                    style={{ color: "gray", marginLeft: "10px" }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            }
          />
        </div>
      )}
    </>
  );
};

export default LeaveView;
